import axios from "axios";
import { API_HOST } from "../constants";

const api = axios.create({
  baseURL: API_HOST,
});

export { api };
